// extracted by mini-css-extract-plugin
module.exports = {"wrap":"transition_cover-module--wrap--LN3xy","inner":"transition_cover-module--inner--mfW8C","fadeOutInner":"transition_cover-module--fadeOutInner--2ZIKO"};